import React, { FC } from 'react';

import { Icon } from 'common/components';
import { Action, EntityActions, EntityType } from 'common/enums';
import { ICON_COLLECTION } from 'assets/media/icons';
import { GridApi } from 'ag-grid-community/dist/lib/gridApi';
import './WhatsNewActionCellRenderer.scss';

type WhatsNewActionCellRendererProps = {
    data: any;
    onAction: (action: number, data: any, api: any) => any;
    api: GridApi;
    isSetUpDisabled: boolean;
};

const WhatsNewActionCellRenderer: FC<WhatsNewActionCellRendererProps> = ({
    data,
    onAction,
    api,
    isSetUpDisabled = false
}: WhatsNewActionCellRendererProps) => {
    const isEditHidden = data.type === EntityType.Indicator;

    return (
        <div className="action-cell">
            {isEditHidden ? (
                <span className="empty" />
            ) : (
                <span
                    className={
                        isSetUpDisabled ? 'edit-icon-container-disabled' : 'edit-icon-container'
                    }
                    title="Edit"
                    onClick={() => (isSetUpDisabled ? null : onAction(Action.Edit, data, api))}>
                    <Icon
                        // className="action-icon"
                        src={ICON_COLLECTION.IC_Edit}
                        title={EntityActions.Edit}
                    />
                </span>
            )}

            <span
                className={
                    isSetUpDisabled ? 'delete-icon-container-disabled' : 'delete-icon-container'
                }
                onClick={() => (isSetUpDisabled ? null : onAction(Action.Delete, data, api))}>
                <Icon
                    className="action-icon"
                    src={ICON_COLLECTION.IC_Delete}
                    title={EntityActions.Delete}
                />
            </span>
        </div>
    );
};
export default WhatsNewActionCellRenderer;
